import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import styles from "./Banner.module.scss";
import { cloneDeep } from "lodash";
import { useSchedulingABVariant } from "../../utils/useSchedulingABVariant";

export interface BannerProps {
  mainSetting: any | null;
}

export const MainBanner: React.FC<BannerProps> = ({
  mainSetting,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  let banner = (mainSetting && 
                mainSetting.length === 1 && 
                mainSetting[0] &&
                mainSetting[0]["banner"]) ? cloneDeep(mainSetting[0]["banner"]) : null;
  if(banner && banner.start_at && banner.end_at) {
    banner.enabled = (dayjs() > dayjs(banner.start_at) && dayjs() < dayjs(banner.end_at))
  }
  React.useEffect(() => {
    if (!containerRef.current) return;
    const links = containerRef.current.querySelectorAll<HTMLAnchorElement>("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noreferrer");
    });
  }, [banner?.html]);
  if (banner && banner.enabled) {
    const styleMain = {
      color: banner.text_color,
      backgroundColor: banner.background_color
    }
    return (
      <div
        className={cx(styles.banner, { [styles.v3]: isV3 })}
        ref={containerRef}
        dangerouslySetInnerHTML={{
          __html: banner.html.replace(/\u003C/g, "<").replace(/\u003/g, ">"),
        }}
        style={styleMain}
      />
    );
  } else {
    return null;
  }
};
